import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { FileAssetsDataObject, FolderAssetDataObject } from 'models/service';

export const createAsset = async ({ body }: BodyRequest<FormData>) =>
  apiClient.post<
    FileAssetsDataObject | FolderAssetDataObject,
    ApiClientResponse<FileAssetsDataObject | FolderAssetDataObject>
  >(routes.assets.create, body);
